
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/textEditor/textEditor.scss.css.virtualfile';
        module.exports = {"textEditor__pimple":"_textEditor__pimple_dhq68_1","textEditorPimple":"_textEditor__pimple_dhq68_1"};